import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Pagination from "../Pagination/pagination";
import ListControls from "../ListControls/ListControls";
import ExportCsvButton from "../ExportCsvButton";
import SearchIcon from "@mui/icons-material/Search";
import Loader from "../../Loader/Loader";
import {
  blockuser,
  deleteuser,
  deliverypersonlist,
  exportDriversCsv,
} from "../../service/Mainservice";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Deletepopup from "../Vendor/Aresure";
import DeleteIcon from "@mui/icons-material/Delete";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import StarIcon from "@mui/icons-material/Star";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import "./Driver.css";
import { Tooltip } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const DeliverypersonList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [searchvalue, setsearchvalue] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [id, setid] = useState();
  const [showdelete, setshowdelete] = useState(false);

  // Filter states
  const [vehicleFilter, setVehicleFilter] = useState("all");
  const [zoneFilter, setZoneFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");

  const navigate = useNavigate();

  // Fetch on mount and when any filter/search/pagination changes
  useEffect(() => {
    getData(1);
  }, [searchvalue, vehicleFilter, zoneFilter, statusFilter, sortBy, sortOrder]);

  const getData = async (page) => {
    try {
      setloading(true);
      const response = await deliverypersonlist(
        page,
        searchvalue,
        vehicleFilter,
        statusFilter,
        zoneFilter,
        { sortBy, sortOrder },
      );
      setData(response?.data?.data || []);
      setpagination(response?.data?.pagination || { page: 1 });
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handledelete = async () => {
    try {
      setloading(true);
      await deleteuser(id, "delivery");
      getData(1);
      setshowdelete(false);
    } catch (error) {
      setshowdelete(false);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleunblock = async (id, action) => {
    try {
      setloading(true);
      await blockuser(id, "delivery", action);
      getData(1);
    } catch (error) {
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  // Navigate to driver details
  const handleView = (item) => {
    navigate("/Driver_Details", {
      state: { id: item.id },
    });
  };

  // Helper for status badge (still used for display)
  const getStatusBadge = (status) => {
    const map = {
      online: { label: "Online", className: "status_online" },
      offline: { label: "Offline", className: "status_offline" },
      "on delivery": { label: "On Delivery", className: "status_ondelivery" },
      suspended: { label: "Suspended", className: "status_suspended" },
    };
    const key = status?.toLowerCase() || "offline";
    return map[key] || map.offline;
  };

  // Build dropdown options from the current data (useful for UI, but filters are server-side)
  // We'll still compute unique values for the dropdowns from the fetched data.
  const uniqueZones = [
    ...new Set(data.map((item) => item.zone).filter(Boolean)),
  ];
  const uniqueVehicleTypes = [
    ...new Set(
      data
        .map((item) => item.vehicle?.type || item.vehicleType)
        .filter(Boolean),
    ),
  ];
  const uniqueStatuses = [
    ...new Set(data.map((item) => item.status).filter(Boolean)),
  ];

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Drivers</h1>
          <div className="searchicon">
            <SearchIcon />
            <input
              type="search"
              placeholder="Search by name, email, phone..."
              onChange={(e) => setsearchvalue(e.target.value)}
              autoComplete="off"
            />
          </div>
        </div>

        <ListControls sortOptions={[{value:"createdAt",label:"Created date"},{value:"fullName",label:"Name"},{value:"email",label:"Email"},{value:"mobilenumber",label:"Phone"},{value:"isVerify",label:"Verification"}]} sortBy={sortBy} sortOrder={sortOrder} onSortByChange={setSortBy} onSortOrderChange={setSortOrder} />
        <ExportCsvButton exportRequest={exportDriversCsv} filters={{ search: searchvalue, status: statusFilter === "all" ? "" : statusFilter, vehicleType: vehicleFilter === "all" ? "" : vehicleFilter, zone: zoneFilter === "all" ? "" : zoneFilter, sortBy, sortOrder }} filename="drivers.csv" />
        {/* Filters */}
        <div className="filters_row">
          <div className="filter_group">
            <label>Vehicle Type</label>
            <select
              value={vehicleFilter}
              onChange={(e) => setVehicleFilter(e.target.value)}
            >
              <option value="all">All Types</option>
              {uniqueVehicleTypes.map((type) => (
                <option key={type} value={type}>
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </option>
              ))}
            </select>
          </div>
          <div className="filter_group">
            <label>Zone</label>
            <select
              value={zoneFilter}
              onChange={(e) => setZoneFilter(e.target.value)}
            >
              <option value="all">All Zones</option>
              {uniqueZones.map((zone) => (
                <option key={zone} value={zone}>
                  {zone}
                </option>
              ))}
            </select>
          </div>
          <div className="filter_group">
            <label>Status</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All Status</option>
              {uniqueStatuses.map((status) => (
                <option key={status} value={status}>
                  {status.charAt(0).toUpperCase() + status.slice(1)}
                </option>
              ))}
            </select>
          </div>
        </div>

        {data.length > 0 ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Driver</th>
                    <th>Vehicle</th>
                    <th>Status</th>
                    <th>Rating</th>
                    <th>Deliveries</th>
                    <th>Zone</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => {
                    const status = getStatusBadge(item.status);
                    const vehicleDisplay = item.vehicle
                      ? `${item.vehicle.make || ""} ${item.vehicle.model || ""} ${item.vehicle.licensePlate ? `(${item.vehicle.licensePlate})` : ""}`
                      : item.vehicleType || "N/A";

                    return (
                      <tr key={item.id}>
                        <td className="driver_info">
                          <div className="driver_avatar">
                            {item.image ? (
                              <img src={item.image} alt={item.fullName} />
                            ) : (
                              <PersonOutlineIcon />
                            )}
                          </div>
                          <div>
                            <div className="driver_name">{item.fullName}</div>
                            <div className="driver_contact">
                              {item.mobilenumber}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="vehicle_cell">
                            <DirectionsCarIcon fontSize="small" />
                            <span>{vehicleDisplay}</span>
                          </div>
                        </td>
                        <td>
                          <span className={`status_badge ${status.className}`}>
                            {status.label}
                          </span>
                        </td>
                        <td>
                          <div className="rating_cell">
                            <StarIcon fontSize="small" />
                            <span>{item.totalRating || 0}</span>
                          </div>
                        </td>
                        <td>{item.totalDeliveries || 0}</td>
                        <td>{item.zone || "N/A"}</td>
                        <td>
                          <div className="action_buttons">
                            <Tooltip title="View Details" arrow>
                              <VisibilityIcon
                                sx={{
                                  color: "#3b82f6",
                                  fontSize: "28px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleView(item)}
                              />{" "}
                            </Tooltip>

                            {item.isBlocked ? (
                              <Tooltip title="Unblock User" arrow>
                                <BlockIcon
                                  sx={{
                                    color: "#ef4444",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleunblock(item.id, "unblock");
                                  }}
                                />{" "}
                              </Tooltip>
                            ) : (
                              <Tooltip title="Block User" arrow>
                                <CheckCircleIcon
                                  sx={{
                                    color: "#22c55e",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleunblock(item.id, "block");
                                  }}
                                />
                              </Tooltip>
                            )}
                            <Tooltip title="Delete User" arrow>
                              <DeleteIcon
                                sx={{
                                  color: "var(--red)",
                                  fontSize: "28px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setid(item.id);
                                  setshowdelete(true);
                                }}
                              />
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination pagedata={pagination} onPageChange={getData} />
          </>
        ) : (
          !loading && (
            <p className="nodata">No drivers match the current filters.</p>
          )
        )}
      </div>

      <Deletepopup
        isOpen={showdelete}
        setisOpen={setshowdelete}
        handledelete={handledelete}
      />

      {loading && <Loader />}
    </>
  );
};

export default DeliverypersonList;
